import { useEffect, useState } from "react";
import { useDebouncedSearch } from "../../../../../hooks/useDebouncedSearch";
import recoverIcon from '../../../../../assets/images/icons8-reset-24.png';
import WebService from "../../../../../utility/WebService";
import { toast } from "../../../../../components/AppModal/AppModal";
import WarningModal from "../../../../../components/Warning/Warning";
import SucessModal from "../../../../../components/SucessModal/Sucess";
import SpringMoneyPagination from "../../../../../components/SpringMoney/Pagination/SpringMoneyPagination";
import HelpButton from "../../../../../components/Help/HelpButton";
import "../../../../Admin/Masters/MasterList.css";
import { useMenuBack } from "../../../../../hooks/useMenuBack";

/* ---- inline stroke icons (apv style, kept local to this screen) ---- */
const IconSearch = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></svg>
);
const IconArrowLeft = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M11 18l-6-6 6-6" /></svg>
);
const IconArrowRight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 5l7 7-7 7" /></svg>
);
const IconStar = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 18.8 6.2 21.9l1.1-6.5L2.6 10.7l6.5-.9L12 3z" /></svg>
);

const ArchivedFixedReturnandRetirementProducts = () => {
  const goBack = useMenuBack();
  const [showLoader, setShowLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  const appliedSearch = useDebouncedSearch(searchText);
  const [list, setList] = useState<any[]>([]);
  const [sucessMessage, setSucessMessage] = useState<any>();
  const [isShowSucessModal, setShowSucessModal] = useState(false);
  const [warningMessage, setWarningMessage] = useState<any>();
  const [isShowWarningModal, setShowWarningModal] = useState(false);
  const pmUserDetail: any = (() => { try { return JSON.parse(localStorage.getItem("user_Detail") || "{}"); } catch (e) { return {}; } })();
  const pageSizeKey = "ml_pagesize_fixed_return_products_archived_page_size_" + (pmUserDetail?.user_id || "default");
  const PAGE_SIZES = [10, 25, 100, 250, 500];
  const readSavedPageSize = () => {
    const v = parseInt(localStorage.getItem(pageSizeKey) || "", 10);
    return PAGE_SIZES.indexOf(v) >= 0 ? v : 25;
  };
  const [itemsCountPerPage, setItemsCountPerPage] = useState<number>(() => readSavedPageSize());
  const [defaultPageSize, setDefaultPageSize] = useState<number>(() => readSavedPageSize());
  const [currentPageNo, setCurrentPageNo] = useState<number>(1);
  const [sortType, setSortType] = useState<string>("");
  const [sortTypeColName, setSortTypeColName] = useState<string>("");
  const [goToPageNumber, setGoToPageNumber] = useState<string>("");
  const [TotalPages, setTotalPages] = useState<number>();
  const [totalItems, setTotalItems] = useState<number>();

  const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const highlightMatch = (text: any) => {
    const term = (searchText || "").trim();
    if (term.length < 1 || text == null) return text;
    try {
      return String(text)
        .split(new RegExp(`(${escapeRegExp(term)})`, "ig"))
        .map((part, i) =>
          part.toLowerCase() === term.toLowerCase()
            ? <mark key={i} className="ml-hl">{part}</mark>
            : part
        );
    } catch (e) {
      return text;
    }
  };

  useEffect(() => {
    getList();
  }, [appliedSearch, sortType, sortTypeColName, currentPageNo, itemsCountPerPage]);

  useEffect(() => {
    WebService.getAPI({ action: `/v2/UserSetting/Get?key=fixed_return_products_archived_page_size`, body: null })
      .then((res: any) => {
        const v = parseInt(res?.value, 10);
        if (PAGE_SIZES.indexOf(v) >= 0) {
          setDefaultPageSize(v);
          setItemsCountPerPage(v);
          try { localStorage.setItem(pageSizeKey, String(v)); } catch (e) { }
        }
      })
      .catch(() => { });
  }, []);

  const getList = () => {
    setShowLoader(true);
    WebService.postAPI({
      action: `/v2/CommonProductParameters/ArchiveList?page=${currentPageNo}&sortType=${sortType}&columnName=${sortTypeColName}&limit=${itemsCountPerPage}&keyword=${encodeURIComponent(appliedSearch)}`,
    })
      .then((res: any) => {
        setTotalItems(res.total_count);
        setShowLoader(false);
        setList(res.list || []);
      })
      .catch(() => {
        setShowLoader(false);
      });
  };

  const onRestore = (id: Number) => {
    WebService.postAPI({
      action: `/v2/CommonProductParameters/Restore?id=${id}`,
      body: null
    })
      .then((res: any) => {
        setShowSucessModal(true);
        setSucessMessage(res.message);
        getList();
      })
      .catch((e) => {
        setShowWarningModal(true);
        setWarningMessage(e.response.data.message);
      });
  };

  const sucessCloseModal = () => {
    setShowSucessModal(false);
    setShowLoader(false);
  };

  const warningCloseModal = () => {
    setShowWarningModal(false);
    setShowLoader(false);
  };

  const handlePagination = (itemCount: number) => {
    setItemsCountPerPage(itemCount);
    setCurrentPageNo(1);
  };

  const saveDefaultPageSize = () => {
    try { localStorage.setItem(pageSizeKey, String(itemsCountPerPage)); } catch (e) { }
    setDefaultPageSize(itemsCountPerPage);
    WebService.postAPI({
      action: `/v2/UserSetting/Save`,
      body: { key: "fixed_return_products_archived_page_size", value: String(itemsCountPerPage) }
    }).catch(() => { });
    toast.success(`Showing ${itemsCountPerPage} per page by default from now on.`);
  };

  const handleGoToPageInput = (e: any) => {
    if (e.key === "Enter" && goToPageNumber !== "") {
      if (TotalPages && Number(goToPageNumber) > TotalPages) {
        setCurrentPageNo(TotalPages);
      } else {
        setCurrentPageNo(Number(goToPageNumber));
      }
    }
  };

  const toggleSort = (col: string) => {
    if (sortTypeColName === col) {
      setSortType(sortType === "ASC" ? "DESC" : "ASC");
    } else {
      setSortTypeColName(col);
      setSortType("ASC");
    }
    setCurrentPageNo(1);
  };
  const SortTh = ({ label, col, cls }: { label: string; col: string; cls?: string }) => (
    <th
      className={(cls ? cls + " " : "") + "ml-sortable" + (sortTypeColName === col ? " sorted-" + (sortType === "ASC" ? "asc" : "desc") : "")}
      onClick={() => toggleSort(col)}
      aria-sort={sortTypeColName === col ? (sortType === "ASC" ? "ascending" : "descending") : "none"}
    >
      {label}
      <span className="ml-sort-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6" /></svg></span>
    </th>
  );

  return (
    <>
      <WarningModal
        show={isShowWarningModal}
        isClose={warningCloseModal}
        message={warningMessage}
      />
      <SucessModal
        show={isShowSucessModal}
        isClose={sucessCloseModal}
        message={sucessMessage}
      />
      <div className="page-content-wraper ml-page">
        <div className="ml-head">
          <div className="ml-head-l">
            <button type="button" className="ml-back" title="Back" onClick={() => goBack()}>
              <IconArrowLeft />
            </button>
            <div>
                <h1 className="ml-title">Archived Fixed Return and Retirement Products</h1>
                <div className="ml-sub">Product Master &middot; Archived Fixed Return and Retirement Products</div>
            </div>
          </div>
          <div className="ml-head-r">
            <HelpButton />
          </div>
        </div>

        <div className="ml-card">
          <div className="ml-toolbar">
            <div className="ml-sizes">
              <span>Show:</span>
              {PAGE_SIZES.map((size) => (
                <button
                  key={size}
                  type="button"
                  onClick={() => handlePagination(size)}
                  className={`ml-size-btn ${itemsCountPerPage === size ? "active" : ""}`}
                >
                  {size}
                </button>
              ))}
              <span className="ml-sizes-sep"></span>
              <button
                type="button"
                className="ml-setdefault"
                onClick={saveDefaultPageSize}
                disabled={itemsCountPerPage === defaultPageSize}
                title="Remember this page size for your next login"
              >
                <IconStar /> Set as default
              </button>
              <span className="ml-defnote">Default: {defaultPageSize}</span>
            </div>
            <div className="ml-tools">
              <div className="ml-search">
                <IconSearch />
                <input
                  onChange={(e) => { setSearchText(e.target.value); setCurrentPageNo(1); }}
                  value={searchText}
                  type="search"
                  placeholder="Search products…"
                />
              </div>
            </div>
          </div>

          <div className="ml-tablewrap">
            <table className="ml-table">
              <thead>
                <tr>
                  <SortTh label="Product Category" col="issuer_category" />
                  <SortTh label="Company" col="company_name" cls="text-center" />
                  <SortTh label="Product Name" col="product_name" cls="text-center" />
                  <SortTh label="Locking Period By Income Tax" col="locking_period_by_income_tax" cls="text-center" />
                  <SortTh label="Locking Period By Vendor" col="locking_period_by_vendor" cls="text-center" />
                  <th className="text-center" style={{ width: "95px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {showLoader && Array.from({ length: 8 }).map((_, i) => (
                  <tr key={'sk-' + i} className="ml-skrow">
                    <td><span className="ml-sk" style={{ width: "60%" }}></span></td>
                    <td className="text-center"><span className="ml-sk" style={{ width: "55%", margin: "0 auto" }}></span></td>
                    <td className="text-center"><span className="ml-sk" style={{ width: "55%", margin: "0 auto" }}></span></td>
                    <td className="text-center"><span className="ml-sk" style={{ width: "48px", margin: "0 auto" }}></span></td>
                    <td className="text-center"><span className="ml-sk" style={{ width: "48px", margin: "0 auto" }}></span></td>
                    <td className="text-center"><span className="ml-sk ml-sk-pill" style={{ width: "40px", margin: "0 auto" }}></span></td>
                  </tr>
                ))}
                {!showLoader && list.length > 0 && list.map((res, index) => {
                  return (
                    <tr key={index}>
                      <td className="ml-name">{res.issuer_category ? highlightMatch(res.issuer_category) : "-"}</td>
                      <td className="text-center">{res.company_name ? highlightMatch(res.company_name) : "-"}</td>
                      <td className="text-center">{res.product_name ? highlightMatch(res.product_name) : "-"}</td>
                      <td className="text-center">{res.locking_period_by_income_tax ? highlightMatch(res.locking_period_by_income_tax) : "-"}</td>
                      <td className="text-center">{res.locking_period_by_vendor ? highlightMatch(res.locking_period_by_vendor) : "-"}</td>
                      <td className="text-center">
                        <div className="ml-actions">
                          <button type="button" className="ml-act green" title="Restore" onClick={() => onRestore(res.common_product_parameters_id)}>
                            <img src={recoverIcon} width={18} height={18} alt="Restore" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          {list.length == 0 && showLoader == false &&
            <div className="ml-empty">
              <div className="ml-empty-ic">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="7" />
                  <path d="M21 21l-4.3-4.3" />
                </svg>
              </div>
              <h2>No Archived Fixed Return and Retirement Products Found</h2>
              <p>Try a different search term.</p>
            </div>
          }

          {totalItems && totalItems > 0 &&
            <div className="ml-pager">
              <div className="ml-total">Total count: <b>{totalItems}</b></div>
              <div>
                <SpringMoneyPagination
                  currentPageNo={currentPageNo}
                  setCurrentPageNo={setCurrentPageNo}
                  itemsCountPerPage={itemsCountPerPage}
                  totalItems={totalItems}
                  TotalPages={TotalPages}
                  setTotalPages={setTotalPages}
                />
              </div>
              <div className="ml-goto">
                <span>Go to page</span>
                <input
                  onKeyDown={handleGoToPageInput}
                  type="number"
                  value={goToPageNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[1-9]\d*$/.test(value) || value === "") {
                      setGoToPageNumber(value);
                    }
                  }}
                />
                <a title="Next" onClick={() => {
                  if (goToPageNumber !== "") {
                    if (TotalPages && (Number(goToPageNumber) > TotalPages)) {
                      setCurrentPageNo(TotalPages);
                    } else {
                      setCurrentPageNo(Number(goToPageNumber));
                    }
                  }
                }}>
                  <IconArrowRight />
                </a>
              </div>
            </div>
          }
        </div>
      </div>
    </>
  );
};
export default ArchivedFixedReturnandRetirementProducts;
